module.exports = __webpack_public_path__ + "img/mob2.ef4f188b.png";